var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3635 6.13809C15.3334 6.63333 16 7.67714 16 8.88095C16 10.0192 15.4019 11.0128 14.5197 11.5362C14.5357 11.665 14.5448 11.7945 14.5448 11.927C14.5448 13.6109 13.2436 14.9747 11.636 14.9747C11.2772 14.9747 10.9343 14.9099 10.6182 14.7857C10.1466 15.8021 9.15156 16.5 7.99962 16.5C6.84844 16.5 5.85344 15.8021 5.38108 14.7857C5.0649 14.9107 4.72206 14.9762 4.36398 14.9762C2.75644 14.9762 1.45517 13.6124 1.45517 11.9286C1.45517 11.796 1.46431 11.6665 1.47955 11.537C0.595781 11.0128 0 10.02 0 8.88095C0 7.67562 0.666635 6.63333 1.63573 6.13809C1.5184 5.8059 1.45517 5.44781 1.45517 5.07143C1.45517 3.38762 2.75644 2.02381 4.36398 2.02381C4.72206 2.02381 5.06566 2.08857 5.38184 2.21429C5.85496 1.19867 6.84996 0.5 8.00038 0.5C9.1508 0.5 10.1473 1.19714 10.6182 2.21581C10.9351 2.08933 11.2779 2.02533 11.636 2.02533C13.242 2.02533 14.5448 3.38762 14.5448 5.07143C14.5448 5.44857 14.4808 5.80667 14.3635 6.13809Z",
    fill: "#B8135D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4282 6.2462L6.92055 10.7538L4.66675 8.5",
    stroke: "white",
    strokeWidth: 1.33333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedBadge);
export default __webpack_public_path__ + "static/media/verified-badge.52c753fb2d8e37c11750098fe2d262a9.svg";
export { ForwardRef as ReactComponent };